import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  constructor(
    public toastController: ToastController
  ) { }

  /* Top */
  async msgAppTop(msg: string, state:string) {    
    const toast = await this.toastController.create({
      message: msg,
      color: state,
      position: 'top',
      duration: 2000
    });
    toast.present();
  }

  /* Center */
  async msgAppCenter(msg: string, state:string) {    
    const toast = await this.toastController.create({
      message: msg,
      color: state,
      position: 'middle',
      duration: 2000
    });
    toast.present();
  }

  /* Bottom */
  async msgAppBottom(msg: string, state:string) {    
    const toast = await this.toastController.create({
      message: msg,
      color: state,
      position: 'bottom',
      duration: 2000
    });
    toast.present();
  }
}
